import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getSearch } from '../../common/services/selectors';
import * as Actions from '../../common/services/actions';
import { navigate } from '../../common/services/navigation';

function SearchBox({ search }) {
	let searchInput = null;

	const click = e => {
		e.preventDefault();
		e.stopPropagation();
		navigate(search, { term: searchInput.value, pageIndex: 0 });
	};

	const keyDown = e => {
		if (e.keyCode === 13) {
			e.preventDefault();
			e.stopPropagation();
		}
	};

	const keyUp = e => {
		if (e.keyCode === 13) {
			e.preventDefault();
			e.stopPropagation();
			navigate(search, { term: searchInput.value, pageIndex: 0 });
		}
	};

	const setSearchInput = input => {
		searchInput = input;
		if (input && search && search.term) {
			input.value = search.term;
		}
	};

	return (
			<div className="large-6 large-push-3 column">
				<div className="search__input">
					<label htmlFor="search-box-head" className="visuallyhidden">Search</label>
					<input onKeyDown={keyDown} onKeyUp={keyUp} className="search-input" id="search-box-head" name="search-box-head" placeholder='Search...' ref={setSearchInput} />	
					<button id="GenericSearch" onClick={click} className="site-search__button">
						<svg xmlns="http://www.w3.org/2000/svg" className="icon icon-search">
							<use xlinkHref="#icon-search"></use>
						</svg>
					</button>
				</div>	
			</div>
	);
}

const mapStateToProps = state => ({ search: getSearch(state) });

const mapDispatchToProps = dispatch => ({
	setSearchTerm: (term) => {
		dispatch(Actions.setSearchTerm(term));
	} 
});

SearchBox.propTypes = {
	search: PropTypes.object,
	setSearchTerm: PropTypes.func
	
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBox);
